module.exports = __webpack_public_path__ + "media/Video 118.23db18d8.mp4";